import ActivateLinkExpired from './ActivateLinkExpired';

export default ActivateLinkExpired;